import React, { Component } from "react";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import subNavStyles from "../../../../../shared/subnav/subNavStyles";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core";
import styles from "./ModifyReservationPrice.module.scss";

const StyledSelect = withStyles({
  select: {
    width: 250,
    borderRadius: 5,
    border: "solid 1px #d8d8d8",
    backgroundColor: "white",
    fontFamily: "FordAntenna-Regular, sans-serif",
    color: "#102b4e",
    fontSize: 14,
    lineHeight: 1.43,
    letterSpacing: 1,
    paddingLeft: 10,
    "&:focus": {
      background: "transparent",
    },
  },
})(Select);

const StyledMenuItem = withStyles({
  root: {
    fontFamily: "FordAntenna-Regular, sans-serif",
    fontSize: 14,
    lineHeight: 1.43,
    letterSpacing: 1,
    color: "#102b4e",
    padding: 10,
    margin: 0,
  },
})(MenuItem);

class TypeOfVehicleDropdown extends Component {
  render() {
    return (
      <div id="vehicleTypeDropdown" className={styles.dropdownDiv}>
        <FormControl id="menu">
          <StyledSelect
            name="typeOfVehicleDropdown"
            id="selectTypeOfVehicleDropdown"
            className={styles.dropdown}
            IconComponent={() => (
              <KeyboardArrowDown style={subNavStyles.icon} />
            )}
            value={this.props.selectedVehicleType}
            onChange={(event) => this.props.updateVehicleType(event)}
          >
            {this.props.listOfVehicleTypes.map((vehicleType) => {
              return (
                <StyledMenuItem
                  id={vehicleType}
                  data-testid={vehicleType}
                  key={vehicleType}
                  value={vehicleType}
                >
                  {vehicleType}
                </StyledMenuItem>
              );
            })}
          </StyledSelect>
        </FormControl>
      </div>
    );
  }
}

export default TypeOfVehicleDropdown;
